export default "__VITE_ASSET__35cf0234__"